/**
 * Created by zad on 17/9/29.
 */
export default function chainFunc(...fns) {
  const len = fns.length;
  return function chain(...args) {
    for (let i = 0; i < len; i++) {
      const fn = fns[i];
      if (fn && typeof fn === 'function') {
        fn.apply(this, args);
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/utils/chainFunc.js